module.exports = __webpack_public_path__ + "img/s1v1.21cbf481.jpeg";